import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!

  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.media.Link,
    class: _normalizeClass({ supp: _ctx.media.Support })
  }, [
    (_ctx.media.Collection == 'fas')
      ? (_openBlock(), _createBlock(_component_ic, {
          key: 0,
          icon: ['fas', _ctx.media.Icon]
        }, null, 8, ["icon"]))
      : (_openBlock(), _createBlock(_component_ic, {
          key: 1,
          icon: ['fab', _ctx.media.Icon]
        }, null, 8, ["icon"]))
  ], 10, _hoisted_1))
}